import { Link } from 'react-router-dom';

import allocabLogo from '../../assets/images/allocab-logo.svg';
import { LocaleSwitch } from '../../components/locale-switch/LocaleSwitch';
import { constants } from '../../constants';

export const HeaderAnonymous = () => {
  return (
    <header className="flex items-center bg-background h-16 justify-between border-b px-2">
      <Link to={constants.isHotels ? constants.redirectionHotel : constants.legacyWebappHost}>
        {constants.isHotels ? <p>Allocab Hotels</p> : <img src={allocabLogo} alt="Logo Allocab" className="h-6" />}
      </Link>
      <LocaleSwitch />
    </header>
  );
};
